/* 1.引入文件 */
import axios from 'axios'        //引入 axios库
import qs from 'qs'              //引入 node中自带的qs模块（数据格式转换）
import store from '../../store'
import router from '../../router'
import { Dialog} from 'vant';
// import {Decrypt, Encrypt} from './Crypto.js';
// https.createServer(options, app).listen(443)
/* 2.全局默认配置 */
let baseURL = null
let otherURL = null
let accessToken = '';
axios.defaults.headers.common['Authorization'] = accessToken;
axios.defaults.headers.common['accept'] = accessToken;
// 判断开发环境（一般用于本地代理）

if (process.env.NODE_ENV === 'development') { // 开发环境
    // baseURL = '/api'    // 你设置的本地代理请求（跨域代理），下文会详细介绍怎么进行跨域代理
        baseURL = 'https://liantaapi.lianta520.com/api'
        otherURL = '/foo'
} else {                                      // 编译环境
    if (process.env.type === 'test') {        // 测试环境
        baseURL = 'https://liantaapi.lianta520.com/api'
        otherURL = 'http://txggpic.oss-cn-shenzhen.aliyuncs.com'
    } else {                                  // 正式环境
        baseURL = 'https://liantaapi.lianta520.com/api'
        otherURL = 'http://txggpic.oss-cn-shenzhen.aliyuncs.com'
    }
}
// 配置axios的属性
const Axios = axios.create({
	baseURL:baseURL, 		      // 后台服务地址
	timeout: 60000, 		      // 请求超时时间1分钟
	responseType: "json",
	withCredentials: false    // 是否允许带cookie这些
});

 let configUrl = '';
/* 3.设置拦截器 */  
/*如果不是用创建实例的方式配置，那么下面的Axios都要换成axios,也就是文件开头你用import引入axios
时定义的变量*/
Axios.interceptors.request.use((config) => {
  store.dispatch('global/setLoading', true);
  let accessToken = localStorage.getItem('token');
  // let accessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxIiwicGhvbmVfbnVtYmVyIjoiMTMyNjUwODMzNDIiLCJuYmYiOjE2NTA3ODI1NjksImV4cCI6MTY1MDg2ODk2OSwiaXNzIjoiYmxkLnRhbmh1YSIsImF1ZCI6ImJsZC50YW5odWEifQ.bhNGvjOcZnVIHBXmC8GOwYbmbd2u5oywbrLz9jZWugE'
  if (accessToken&&accessToken!=null) {
    config.headers["Authorization"] ='Bearer'+" "+accessToken;
  }
  
  
  // if(localStorage.getItem('loginData')&&!store.getters['global/s_loginData'].Id){
  //   store.dispatch('global/setLoginData',JSON.parse(localStorage.getItem('loginData')));
  // }
  // if(!store.getters['global/s_loginData'].Id||!localStorage.getItem('openid')){
  //   if(config.url != "ureg" && config.url != "ulogin" && config.url != "uopenid" && config.url != "uOpenidupdate"){
  //     localStorage.removeItem('loginData')
  //     Dialog({message: '请重新登录'});
  //     router.push({name: 'login'})
  //     return;
  //   }
  // }
  // 发送请求前进行拦截
  //  可在此处配置请求头信息
	// config.headers["appkey"] ="...";
 	if (config.method == "post") {
  /*数据转换: axios post方式默认是json格式提交数据，如果使用application/x-www-form-urlencoded数据格式提交，
  要用qs.stringify()进行转换,个人建议不在拦截器中全局配置，因为不够灵活，还有一点是，如果
设置了重新请求的配置，那么重新请求时，请求体中的config里面的传参就会被再次进行qs.stringify()转
换，会使得参数丢失，造成请求失败。*/
 		config.data = qs.stringify(config.data)
 	}
	return config;
  },(error) =>{
    //console.log("错误的传参", 'fail');
  return Promise.reject(error)
  })
Axios.interceptors.response.use((res) => {
//    请求响应后拦截

  if(res.data.code=='-1'){
    Dialog({message: res.data.msg})
  }
  if(res.data.code=='401'){
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
  store.dispatch('global/setLoading', false);
 
  return Promise.resolve(res)
}, (error) => {
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  window.location.reload();
  store.dispatch('global/setLoading', false)
  //alert("网络异常!") 404等问题可以在这里处理
  
  return Promise.reject(error)
  return;
})



// 配置axios的属性
const OtherAxios = axios.create({
	baseURL:otherURL, 		      // 后台服务地址
	timeout: 60000, 		      // 请求超时时间1分钟
	responseType: "json",
	withCredentials: false    // 是否允许带cookie这些
});
/* 3.设置拦截器 */  
OtherAxios.interceptors.request.use((config) => {
  store.dispatch('global/setLoading', true)
  // let accessToken = localStorage.getItem('accessToken');
  // if (accessToken&&accessToken!=null) {
  //   config.headers["Authorization"] ='Bearer'+" "+accessToken;
  // }else{
  //   if(config.url != "OAuth/signIn" ){
  //     Dialog({message: '请重新登录'});
  //     router.push({name: 'login'})
  //     return;
  //   }
  // }
  // 发送请求前进行拦截
  //  可在此处配置请求头信息
	// config.headers["appkey"] ="...";
 	if (config.method == "post") {
  /*数据转换: axios post方式默认是json格式提交数据，如果使用application/x-www-form-urlencoded数据格式提交，
  要用qs.stringify()进行转换,个人建议不在拦截器中全局配置，因为不够灵活，还有一点是，如果
设置了重新请求的配置，那么重新请求时，请求体中的config里面的传参就会被再次进行qs.stringify()转
换，会使得参数丢失，造成请求失败。*/
 		config.data = qs.stringify(config.data)
 	}
	return config;
  },(error) =>{
    //console.log("错误的传参", 'fail');
    return Promise.reject(error)
  })
OtherAxios.interceptors.response.use((res) => {
//    请求响应后拦截
  store.dispatch('global/setLoading', false)
  // if(res.data.code == 200) {                       // 对响应数据做些事
  //     return Promise.resolve(res)
  // }
  // else {
  //   Dialog({message: res.data.msg});
  // }
  return Promise.resolve(res)
}, (error) => {
  store.dispatch('global/setLoading', false)
  //alert("网络异常!") 404等问题可以在这里处理
  return Promise.reject(error)
})


export default {Axios,OtherAxios,baseURL}
